import { getTotalPrice } from "~/domains/product/utils/productDescriptorUtils";
import { Permission, userHasPermission } from "~/domains/user/utils/permissions";
import { type OrderLineItemData } from "~/domains/orders/types/modelsV2";
import { QuoteDetailsEntryStatus } from "~/domains/orders/types/GetItemStatus";
import { multiply } from "~/utils/PriceUtils";
import { type QuoteLineItem } from "~/features/orders/quoteList/api/fetchOrderDetails/dto";
import type { QuoteLinePartMO } from "~/features/orders/common/components/v2/models";

export const getOrderLineItemTotalPrice = (data: OrderLineItemData | QuoteLineItem | QuoteLinePartMO) => {
  let quantity;
  let netPrice;
  if ("confirmedQty" in data) {
    quantity = data.confirmedQty;
    netPrice = data.netPrice;
  } else {
    netPrice = data.price;
    quantity = data.confirmedQuantity;
  }

  const isQtyAvailable = !!quantity;
  if (!isQtyAvailable) {
    // SCHAEFF-31697, SCHAEFF-31776: Use requested quantity for calculations when confirmed quantity is not available
    if ("qty" in data) {
      quantity = data.qty;
    } else {
      quantity = data.requestedQuantity;
    }
  }
  return getTotalPrice(netPrice, quantity);
};
export const getOrderLineItemSurchargeValue = (data: OrderLineItemData | QuoteLineItem | QuoteLinePartMO) => {
  const totalPrice = getOrderLineItemTotalPrice(data);
  const netPrice = "netPrice" in data ? data.netPrice : data.price;
  const surcharge = netPrice?.surcharge ?? 0;
  return multiply(totalPrice, surcharge);
};

export enum QuoteLineItemPriceVisibility {
  VISIBLE,
  PENDING,
  HIDDEN,
}

export function getQuoteLineItemPriceVisibility({
  lineItemStatus,
  quoteStatus,
}: {
  lineItemStatus: QuoteDetailsEntryStatus;
  quoteStatus?: QuoteDetailsEntryStatus;
}) {
  if (userHasPermission(Permission.ADD_TO_QUOTE)) {
    return QuoteLineItemPriceVisibility.VISIBLE;
  }

  if (quoteStatus === QuoteDetailsEntryStatus.EXPIRED) {
    return QuoteLineItemPriceVisibility.HIDDEN;
  }

  switch (lineItemStatus) {
    case QuoteDetailsEntryStatus.IN_CLARIFICATION:
      return QuoteLineItemPriceVisibility.PENDING;
    case QuoteDetailsEntryStatus.REJECTED:
    case QuoteDetailsEntryStatus.EXPIRED:
      return QuoteLineItemPriceVisibility.HIDDEN;
    case QuoteDetailsEntryStatus.ACCEPTED:
    case QuoteDetailsEntryStatus.RELEASED:
    case QuoteDetailsEntryStatus.ALL:
    case QuoteDetailsEntryStatus.ACTIVE:
    default:
      return QuoteLineItemPriceVisibility.VISIBLE;
  }
}
